// @flow
/**
 * Created by Mike Chung on 2/27/18.
 */
import React from "react";
import * as _ from 'lodash';
import './table.css';

type TableProps = {
    className?: string
};

export default function Table(props: TableProps) {

    const {className, ...rest} = props;
    let clazz = `divTable ${_.defaultTo(className, "")}`;
    return (
        <div className={clazz} {...rest} />
    );
}


// WEBPACK FOOTER //
// ./src/components/util/tables/Table.js